import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IGroupService } from 'pages/menuGroupService/interfaces'
import { RootState } from 'store'

export interface IGeneralDataProps {
  groupServiceALl: Array<IGroupService>
}
const initialState = {
  groupServiceALl: []
}
export const generalDataSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    setGroupServicesAll: (
      state: IGeneralDataProps,
      action: PayloadAction<Array<IGroupService>>
    ) => {
      state.groupServiceALl = action.payload
    },
    resetGeneralDataAction: () => initialState
  }
})

export const { setGroupServicesAll, resetGeneralDataAction } =
  generalDataSlice.actions
export const generalDataSelector = (state: RootState) =>
  state.generalDataReducer
export default generalDataSlice.reducer
